import { render, staticRenderFns } from "./PermissionsShow.vue?vue&type=template&id=24714c90&scoped=true"
import script from "./PermissionsShow.vue?vue&type=script&lang=js"
export * from "./PermissionsShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24714c90",
  null
  
)

export default component.exports